var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 107,
    viewBox: "0 0 158 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 107,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_95_2",
    transform: "matrix(0.00752461 0 0 0.0111111 0.161392 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_95_2",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7UlEQVR4nO2cQU7DMBBFZzXh5DTnYRHlQlBuMVVRkFBVBG3i8f/j/yRvWKDnp9ZtqRkzIYQQQgghhBBCCHGPycxmMztva95+xgKFv5vZm5nFzVrN7MXwofD/TRJSltX/L0koWVb//0oGgiyr/6OSARabwv/6Srw8IRnbWjq/mtP4zzsko3PsvZG/1ylD9nyAaHQ4Rp49Lu6tT6bQkRj7yMjX9Z7g/PW0OUo4Eo6Ro46Ln+u1oW9T8aVRbCbXlKdiNDhGGBzpN+LAbmU25IBOh4C0MQdyaQLCBh3AIYWeG/VRIvfcsI8WucfGfdTImQF89MgZIVyRcz4CLw1+J9w33o/iDR59wx8XbLFXxjOZLfZaMTJa7NKRUWIPEbl37KEi94o9ZOTs2ENHzoqtyAmxFfkGhU7AdXTwRw4dIaa3dxm4PrDUjRwjHSOuPyqNEzkqP7IdLHLJ2A4auVRsfTmbgK4bJKALNAnoSlgCuuSYgK7tJoBwF84BHJqCtEEHcjkUxI05oNMukDfkwG7lNuIEjmX+7Xcicm0yryMSxVvEpprXEcRjJKjmdazEg1Fo5nUs5KN+KOZ1LBpeVWycWRV/igF9VfwpRk5W8acYolrFn2IscBX/aXvr97GtE9m//U7k/kIIIYQQQgghhBCWxQVCVmav1FT2GAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.24409838a62357683904e06ee46c1d74.svg";
export { ForwardRef as ReactComponent };